__turbopack_context__.v({
  "arrow": "LocalizationSelect-module-scss-module__BSvSEa__arrow",
  "label": "LocalizationSelect-module-scss-module__BSvSEa__label",
  "select": "LocalizationSelect-module-scss-module__BSvSEa__select",
});
